import { getCookies } from './getToken';
export const getHeaderInfo = async () => {
    const token = getCookies();
    if (token) {
        return {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        };
    }
    return {
        headers: {
            'Content-Type': 'application/json',
        },
    };
};
export const getImageHeaderInfo = async () => {
    const token = getCookies();
    if (token) {
        return {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
            },
        };
    }
    return {
        headers: {
            'Content-Type': 'application/json',
        },
    };
};
